module.exports = __webpack_public_path__ + "img/7_164.c4e8fd2c.png";